import styled, { keyframes } from "styled-components";
import { Box } from "@dealer-center/core-components";
import { Locale } from "@dealer-center/core-labels";
import { FeeGridRow, SR_ONLY_SX } from "../styles/FeeManager.styles";

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const SkeletonRow = styled(FeeGridRow)`
  padding: 12px 8px;
  border-bottom: 1px solid #e5e7eb;
  min-height: 60px;
`;

const SkeletonBox = styled.div<{ width?: string; height?: string }>`
  width: ${props => props.width || "100%"};
  height: ${props => props.height || "20px"};
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 4px;
`;

interface FeeRowSkeletonProps {
  count?: number;
}

export const FeeRowSkeleton = ({ count = 5 }: FeeRowSkeletonProps) => {
  // Stable keys: computing them during render (previously with Math.random)
  // remounted every skeleton row on every render.
  const skeletonKeys = Array.from(
    { length: count },
    (unusedValue, index) => `skeleton-${index}`
  );

  return (
    <>
      {/* The shimmer rows say nothing to a screen reader; this does. */}
      <Box role="status" sx={SR_ONLY_SX}>
        {String(Locale.getText("FEEMANAGER_LOADING"))}
      </Box>
      {skeletonKeys.map(key => (
        <SkeletonRow
          aria-hidden="true"
          data-testid="fee-row-skeleton"
          key={key}
        >
          {/* Name */}
          <SkeletonBox height="40px" width="100%" />

          {/* Amount */}
          <SkeletonBox height="40px" width="100%" />

          {/* Delete button */}
          <SkeletonBox height="28px" width="28px" />
        </SkeletonRow>
      ))}
    </>
  );
};
